import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import i18n from "../i18n";

const Jointeam = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  // eslint-disable-next-line no-unused-vars
  const _ = langTick;

  return (
    <section className="py-20 px-6 sm:px-10 lg:px-20 bg-white">
      <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-md overflow-hidden flex flex-col-reverse lg:flex-row">
        <div className="flex-1 p-8 flex flex-col justify-center">
          <h2 className="text-4xl md:text-3xl font-bold text-gray-800 mb-4">
            {i18n.t("jointeam.title")}
          </h2>

          <p className="text-gray-600 mb-6">{i18n.t("jointeam.text")}</p>

          <Link
            to="/jobs"
            className="w-fit self-start min-w-[140px] h-[44px] border border-blue-600 border-[1px] text-blue-600 text-sm font-medium px-6 rounded-md bg-transparent hover:bg-blue-50 transition-colors duration-200 flex items-center justify-center"
          >
            {i18n.t("jointeam.button")}
          </Link>
        </div>

        <div className="flex-1">
          <img
            src={`${process.env.PUBLIC_URL}/images/join.jpg`}
            alt="Team working"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Jointeam;




